import * as React from "react"
import { batch } from "@preact/signals-react"
import {Chip, Skeleton} from "@mui/material"
import { formatDate, FORMAT_DATE_BACK, getPreviousDate, translateCountryName } from "@ui-seeker/utils"

import { KpiTable } from "@components"
import {DATE_PERIODS, GROUPED_BY, PRODUCT_PAGE_ROUTES} from "@constants"
import {useShareUrl, useToast} from "@hooks"
import { commonFiltersValue } from "@signals"
import { useProductPageKpiRoleConfig, useProductPagesKpiFilters } from "./@hooks"
import { evolutionDataFilters, evolutionSelection, kpiSelected, evolutionCurrentPeriod, productPagesKpiEndDate } from "./@signals"
import CreateReportButton from "./CreateReportButton"


export default function ProductPagesKpiTable() {
	const { buildShareParams } = useShareUrl()
	const { data, aggregation, kpis, isLoading } = useProductPagesKpiFilters()
	const { urlApiExcel } = useProductPageKpiRoleConfig()
    const newFilters = commonFiltersValue.peek()
	const {showToast} = useToast()

	if (isLoading) return <Skeleton variant="rectangular" height={500} />
	if (!kpis?.length) return <></>

	const links = (kpi) => [{
		icon: 'memo-circle-info',
		label: 'Go to details',
		buildUrl: (dataRow, aggregations) => `${PRODUCT_PAGE_ROUTES.DETAILS_PATH}?sp=${buildShareParams({
			...aggregations.includes(GROUPED_BY.COUNTRY) && { country: [dataRow.country] },
			...aggregations.includes(GROUPED_BY.RETAILER) && { retailer: [dataRow.siteID] },
			...aggregations.includes(GROUPED_BY.BRAND) && { brand: [dataRow.brandID] },
			...aggregations.includes(GROUPED_BY.SELLER) && {sellers: [dataRow.sellerID]}
		})}&launch=true`
	},{
		icon: 'chart-line',
		label: 'Show evolution',
		onClick: (dataRow, aggregations) => batch(() => {
            productPagesKpiEndDate.value = newFilters.endDate
            let startDate = formatDate(getPreviousDate({days: 6}, productPagesKpiEndDate.value), { format: FORMAT_DATE_BACK, receivedFormat: "%Y-%m-%dT%H:%M:%S.%LZ" })

            evolutionCurrentPeriod.value = DATE_PERIODS.LAST_7_DAYS

			kpiSelected.value = kpi
			evolutionDataFilters.value = {
				...commonFiltersValue.peek(),
				startDate: startDate,
				endDate: productPagesKpiEndDate.value,
				...aggregations.includes(GROUPED_BY.COUNTRY) && {country: [dataRow.country]},
				...aggregations.includes(GROUPED_BY.RETAILER) && {retailer: [dataRow.siteID]},
				...aggregations.includes(GROUPED_BY.BRAND) && {brand: [dataRow.brandID]},
				...aggregations.includes(GROUPED_BY.SELLER) && {sellers: [dataRow.sellerID]}
			}

			const stringlist = [
				aggregations.includes(GROUPED_BY.COUNTRY) && translateCountryName(dataRow.country),
				aggregations.includes(GROUPED_BY.RETAILER) && dataRow.retailer,
				aggregations.includes(GROUPED_BY.BRAND) && dataRow.brand,
				aggregations.includes(GROUPED_BY.SELLER) && dataRow.seller
			].filter(Boolean)

			evolutionSelection.value = stringlist.join(' - ')
		})
	}]

	const kpisColumns = () => {
		const columns =  []
		kpis.map(({ kpi, label, visibility=true }, idx) => {
			columns.push({ name: kpi, label: label, links: links(kpi), visibility: visibility })
		})
		
		return columns
	}

	return <KpiTable
		id='kpi-table'
		data={data}
		aggregations={aggregation}
		kpis={kpisColumns()}
		options={{
			onDownload: () => showToast.promiseExcel(urlApiExcel),
			customToolbar: () => <CreateReportButton />
		}}
	/>
}